// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — gate-control.styled.classic.js, новая — gate-control.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './gate-control.styled.classic';
import * as cp from './gate-control.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const Item = isCp ? cp.Item : classic.Item;
